<template>
  <div class="box14">
    <div class="content">
      <h1>适学人群</h1>
      <div class="demo" v-for="(item, index) in list" :key="index">
        <div class="icon">
          <img
            :src="
              require(`../../../assets/coursePage/pythonData/box14/icon${
                index + 1
              }.png`)
            "
            alt
          />
        </div>
        <div class="title">{{ item.title }}</div>
        <div class="text" v-html="item.text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list: [
        {
          title: "0基础转行人员",
          text: "数据课程从Python入<br />手，入门简单高效，适合零基础人员。",
        },
        {
          title: "应届大学毕业生",
          text: "缺乏工作经验和技能，对未来没有明确的目标与规划，期望通过学习数据课程进入IT行业。",
        },
        {
          title: "有基础寻求系统提升者",
          text: "具有一定的数据理论或基础，需要掌握系统的数据技术，应用于实际业务。",
        },
        {
          title: "数据开发技术爱好者",
          text: "有较强的逻辑思维能力，需要顺应时代趋势、应对复杂的业务场景处理、对数据行业感兴趣的人员。",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.box14 {
  margin-top: -130px;
  width: 100%;
  padding-bottom: 88px;
  background: linear-gradient(180deg, #ffffff 0%, #eef9ff 100%);
  h1 {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1d2129;
    line-height: 48px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 48px;
  }
  .content {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    position: relative;
    z-index: 7;
    margin: 00px auto 0;
    padding: 130px 40px 48px;

    width: 690px;
    // height: 739px;
    background-color: #ffffff;
    box-shadow: 0px 5px 40px 0px rgba(0, 163, 251, 0.2);
    border-radius: 20px;
    box-sizing: border-box;
    &::after {
      position: absolute;
      left: 50%;
      top: 54%;
      transform: translate(-50%, -50%);
      content: "";
      width: 610px;
      height: 650px;
      background: url("../../../assets/coursePage/pythonData/box14/line.png")
        no-repeat;
      background-position: center;
      background-size: cover;
    }

    .demo {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      text-align: center;

      width: 270px;
      height: 312px;
      align-content: flex-start;
      .icon {
        width: 62px;
        height: 62px;
        background-color: #e0f5ff;
        border-radius: 8px;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .title {
        margin-top: 20px;
        font-family: PingFangSC-Semibold;
        font-size: 26px;
        font-weight: bold;
        width: 100%;
        letter-spacing: 1px;
        color: #0080ff;
      }
      .text {
        margin-top: 20px;
        font-family: PingFang SC;
        font-size: 22px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 38px;
        letter-spacing: 1px;
        color: #002233;
      }
    }
    .demo:nth-child(3) {
      padding-bottom: 30px;
    }
    .demo:nth-child(4),
    .demo:nth-child(5) {
      margin-top: 15px;
    }
    .demo:nth-child(4) {
      width: 280px;
    }
  }
}
</style>
